(() => {
  if (customElements.get('park-responsive-poster')) return;
  class ParkResponsivePoster extends HTMLElement {
    connectedCallback() {
      this.onReady = () => this.connectVideo();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.onReady, { once: true });
      else this.connectVideo();
    }
    connectVideo() {
      if (!this.isConnected || this.mediaQuery) return;
      const video = this.querySelector('video');
      if (!video || (!this.dataset.mobilePoster && !this.dataset.desktopPoster)) return;
      if (this.video !== video) {
        this.desktopPoster = this.dataset.desktopPoster || video.getAttribute('poster');
        this.video = video;
      }
      const breakpoint = Number(this.dataset.breakpoint) || 767;
      this.mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);
      this.updatePoster = () => {
        const poster = this.mediaQuery.matches && this.dataset.mobilePoster ? this.dataset.mobilePoster : this.desktopPoster;
        if (poster) video.setAttribute('poster', poster);
        else video.removeAttribute('poster');
      };
      this.mediaQuery.addEventListener('change', this.updatePoster);
      this.updatePoster();
    }
    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.onReady);
      if (this.mediaQuery) this.mediaQuery.removeEventListener('change', this.updatePoster);
      this.mediaQuery = null;
    }
  }
  customElements.define('park-responsive-poster', ParkResponsivePoster);
})();
